/**
 * Container Component
 *
 * Token-based layout container with responsive max-width and padding.
 * Provides consistent content boundaries across different screen sizes.
 */

import { HTMLAttributes, ReactNode } from 'react'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

export function Container({
  children,
  size = 'lg',
  padding = 'md',
  className = '',
  style = {},
  ...props
}: ContainerProps) {
  const maxWidthMap = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    full: '100%',
  }

  const paddingMap = {
    none: '0',
    sm: 'var(--spacing-md)',
    md: 'var(--spacing-lg)',
    lg: 'var(--spacing-2xl)',
  }

  const containerStyles: React.CSSProperties = {
    maxWidth: maxWidthMap[size],
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: paddingMap[padding],
    paddingRight: paddingMap[padding],
    ...style,
  }

  return (
    <div className={className} style={containerStyles} {...props}>
      {children}
    </div>
  )
}
